/**
 * Shop-v1 was only ever active in arenas created before the shop-v2 release,
 * i.e. arenas with an ID up to this cutoff. Newer arenas have no v1 history,
 * so the legacy read-only v1 pages are hidden for them.
 */
export const MAX_SHOP_V1_ARENA_ID = 25

export function arenaHasShopV1History(
  arenaId: number | bigint | string | null | undefined,
): boolean {
  if (arenaId === null || arenaId === undefined) {
    return true
  }
  return Number(arenaId) <= MAX_SHOP_V1_ARENA_ID
}
